module.exports = __webpack_public_path__ + "static/media/support-dogs-light.e5700210.png";